<template>
  <div>
    <overlay-loader :overlay="true" />
    <span 
      v-if="alert"
      class="alert"
    >
      <v-icon class="alertIcon">mdi-alert</v-icon>
      {{ alertMessage }}
    </span>
  </div>
</template>
<script>
import OverlayLoader from "../../components/OverlayLoader.vue";
export default {
  components: { OverlayLoader },
  name: "Invite",
  data(){
    return {
      alert: false,
      alertMessage: undefined,
    }
  },
  computed: {
    code() {
      return this.$route.query.code;
    },
  },
  mounted() {
    window.localStorage.setItem("code", this.code);
    if (!this.$store.getters.login) {
      this.$router.push("/");
    } 
    else {
      this.$axios
        .post("/challenges/join", { code: this.code })
        .then((response) => {
          this.overlay = false;

          console.log(response.data);

          if (response.data === null) {
            this.alert = true;
            this.alertMessage = "초대 코드가 잘못됐어요. :(";
            return false;
          } else if (response.data === false) {
            this.alert = true;
            this.alertMessage = "자기자신을 초대할 수 없어요.";
            this.$router.push('/pending');
            return false;
          } else {
            window.localStorage.setItem(
              "challengeInfo",
              JSON.stringify(response.data)
            );
            this.$store
              .dispatch("challenge", { body: response.data })
              .then(() => {
                window.localStorage.removeItem("code");
                this.$router.push("/home");
              });
          }
        });
    }
  },
};
</script>
<style lang="scss" scoped>
.alert{
  bottom: 164px;
  color: #fff;
  background-color: rgba(0,0,0,.4);
}
</style>